/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Grid,
  Header,
  Form as FormUi,
  Icon,
  Divider,
  
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/commanReadAxios";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import MandatoryMark from "../common/mandatorymark";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import moment from "moment";
import ReadAxiosc from "../axiosComponent/commonRead";
import GetCity from "./getCityName";
import { GetState } from "./getSateName";

const BranchDetailModal = ({
  id,
  data,
  t,
  ...props
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [VehicleDetail, setVehicleDetail] = useState([]);
  var vendorIndex = 0;

  useEffect(() => {
    getVehicleDetail();
  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  let viewPDF = (e, data) => {
    console.log(data);
    let path = `${process.env.REACT_APP_HIRE}/vendor_onboarding/resource?customerNo=${localStorage.getItem("customerNumber")}&resource_url=${data.pdf_value}`
    window.open(path, "_blank");
  }

  const handleSubmited = () => {
        setmodalOpen(false);
  };

  const getVehicleDetail = () => {
    ReadAxiosc({ url: `masters/branch/${id}` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleDetail([])
          : setVehicleDetail(res.data.resultSet[0]);
      })
      .catch((err) => {
        setVehicleDetail([]);
      });
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        // size="tiny"
        trigger={
        <Button 
            // user_items={object} 
            type="button" 
            add_mode="edit" 
            onClick={handleOpen} 
            size="mini"  
            basic 
            icon
        > 
            <Icon name="eye" /> 
        </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("title") || "Broadcast Shipment"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
                <Grid columns={4} className="ml-2">
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.branch") || "Branch"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchName ? data.vendorBranchName  : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.state") || "State"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        <GetState stateId={data.vendorBranchStateId}/>
                        {/* {data.vendorBranchName ? data.vendorBranchName : "NA"} */}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.address") || "Address"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchAddress ? data.vendorBranchAddress : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.city") || "City"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {props.cityNameField ? (data[props.cityNameField] || "NA")  :  
                        <GetCity cityId={data.vendorBranchCityId}/>
                        }
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.pincode") || "Pincode"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchPincode ? data.vendorBranchPincode : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Divider horizontal>
                        <Header as='h4'>
                        {t("Bank_Details")}
                        </Header>
                    </Divider>
                  <Grid.Row>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.bank_name") || "Bank Name"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchBankName ? data.vendorBranchBankName  : "NA"}
                      </Header>
                    </Grid.Column>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName "
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.acc_number") || "Account Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchAccountNumber? data.vendorBranchAccountNumber  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.acc_holder") || "Account Holder Name"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchBankAccountHolder ? data.vendorBranchBankAccountHolder : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.ifsc_code") || "IFSC Code"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.vendorBranchBankIFSC ? data.vendorBranchBankIFSC  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                 
                  <Divider horizontal>
                        <Header as='h4'>
                        {t("GST_Details")}
                        </Header>
                    </Divider>
                  <Grid.Row>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.gst_number") || "GST Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName fixedLength150"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.isGSTApplicable && data.vendorBranchGST ? data.vendorBranchGST  : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("Is_GST_Applicable") || "Is GST Applicable"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.isGSTApplicable ? "Yes" : "No"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.validityStartDate") || "Validity Start Date"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.isGSTApplicable && data.validityStartDate ? data.validityStartDate.split("-").reverse().join("-") : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("table_header.validityEndDate") || "Validity End Date"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.isGSTApplicable && data.validatityEndDate ? data.validatityEndDate.split("-").reverse().join("-")  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("Charge_Mechanism.title") || "GST Charge Mechanism"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {data.isGSTApplicable && data.gstChargeMechanism ? data.gstChargeMechanism : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>

                  
                </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("ok") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("branch")(BranchDetailModal)
);
